var t=function(){function t(){}return t.prototype.get=function(){return this.config},t.prototype.set=function(t){this.config=t},t}();export{t as ThemeService};
